<script lang="ts">
    export let count = 4;
    /** When true, also reserve the category tabs + position chips above the list. */
    export let showFilters = false;

    const titleWidths = ['w-3/4', 'w-5/6', 'w-2/3', 'w-4/5', 'w-7/12'];
    const sessionWidths = ['w-40', 'w-44', 'w-36', 'w-48', 'w-32'];
    const idWidths = ['w-14', 'w-16', 'w-12', 'w-20', 'w-16'];
</script>

<div class="animate-pulse" data-testid="bills-list-skeleton" aria-busy="true">
    {#if showFilters}
        <div
            class="mt-4 flex gap-6 overflow-hidden border-0 border-b border-solid border-gray-200"
            data-testid="bills-list-skeleton-tabs"
        >
            {#each [{ label: 'w-8', badge: 'w-6', active: true }, { label: 'w-20', badge: 'w-6' }, { label: 'w-14', badge: 'w-5' }, { label: 'w-24', badge: 'w-6' }] as tab}
                <div
                    class="-mb-px flex shrink-0 items-center gap-2 border-0 border-b-2 border-solid pb-3 pt-1
                        {tab.active ? 'border-gray-900' : 'border-transparent'}"
                >
                    <div class="h-4 rounded {tab.label} {tab.active ? 'bg-gray-300' : 'bg-gray-200'}"></div>
                    <div class="h-5 min-w-[1.5rem] rounded-full {tab.badge} {tab.active ? 'bg-gray-300' : 'bg-gray-100'}"></div>
                </div>
            {/each}
        </div>

        <div class="mt-4 flex flex-wrap items-center gap-2" data-testid="bills-list-skeleton-chips">
            {#each [{ w: 'w-24' }, { w: 'w-24' }, { w: 'w-28' }] as chip}
                <div class="inline-flex items-center gap-2 rounded-full border border-solid border-gray-200 px-3 py-1.5">
                    <div class="h-2 w-2 rounded-full bg-gray-300"></div>
                    <div class="h-3.5 rounded bg-gray-200 {chip.w}"></div>
                    <div class="h-3 w-4 rounded bg-gray-100"></div>
                </div>
            {/each}
        </div>
    {/if}

    <div class="{showFilters ? 'mt-4' : ''} overflow-hidden rounded-xl border border-gray-200 bg-white">
        {#if showFilters}
            <div class="flex items-center gap-2 border-0 border-b border-solid border-gray-100 bg-gray-50 px-4 py-2.5">
                <div class="h-3.5 w-24 rounded bg-gray-300"></div>
                <div class="h-3.5 w-5 rounded bg-gray-200"></div>
            </div>
        {/if}
        <ul class="m-0 list-none divide-y divide-gray-100 p-0">
            {#each Array(count) as _, i}
                <li class="m-0 flex w-full items-start gap-4 bg-white px-4 py-3.5">
                    <div class="flex min-w-0 flex-1 flex-col gap-0.5 sm:flex-row sm:gap-4">
                        <div class="h-4 shrink-0 rounded bg-gray-200 sm:w-24 {idWidths[i % idWidths.length]}"></div>
                        <div class="min-w-0 flex-1">
                            <div class="h-4 rounded bg-gray-300 {titleWidths[i % titleWidths.length]}"></div>
                            <div class="mt-1.5 h-3 rounded bg-gray-200 {sessionWidths[i % sessionWidths.length]} sm:mt-1"></div>
                        </div>
                    </div>
                    <div class="mt-0.5 hidden items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-1 sm:inline-flex">
                        <div class="h-1.5 w-1.5 rounded-full bg-gray-300"></div>
                        <div class="h-3 w-14 rounded bg-gray-200"></div>
                    </div>
                </li>
            {/each}
        </ul>
    </div>
</div>
